import React from "react";
import styles from "./MapActivitiesCell.module.css";
import { CustomButton } from "reusable-components/CustomButtonComponent/button";
import { CygnusTooltip } from "reusable-components/CygnusTooltip/CygnusTooltip";

interface MapActivitiesCellProps {
  data?: any;
  onMapActivities?: (returnId: any, taxId: any, documentId: any, sourceName: any) => void;
}

export const MapActivitiesCell: React.FC<MapActivitiesCellProps> = ({
  data,
  onMapActivities,
}) => {
  if (!data) return <></>;

  const destinationReturnId = data.InternalK1SelectedReturnId || data.FileName?.placeholder;
  const isInternalK1 = data.DocumentType === "Internal Schedule K-1";
  const canMap = isInternalK1 && destinationReturnId;
  const disabledReason = !isInternalK1
    ? "Map Activities is available only for Internal Schedule K-1 sources"
    : "Select a Return ID to enable Map Activities";

  return (
    <CygnusTooltip text={disabledReason} disabled={!!canMap}>
      <span
        className={`${styles.mapActivitiesBtnWrapper} ${!canMap ? styles.mapActivitiesBtnWrapperDisabled : ""}`}
      >
        <CustomButton
          variant="default"
          type="button"
          content="Map Activities"
          disable={!canMap}
          onclick={(event: React.MouseEvent) => {
            event.stopPropagation();
            if (canMap) {
              onMapActivities?.(
                destinationReturnId,
                data.SourceTaxId,
                data.DocumentId,
                data.SourceName,
              );
            }
          }}
          className={styles.mapActivitiesBtn}
          wrapperStyle={{ display: 'contents' }}
        />
      </span>
    </CygnusTooltip>
  );
};
